import React, {useState} from "react";
import {getUser, logout} from "../cjauth";

import {LinkGroup, LogoutLink, UserIcon} from "@cjdev-internal/visual-stack/lib/components/SideNav";

export const SideNavUserMenu = () => {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const user = getUser();

  return (user
      ? <LinkGroup className="vs-sidenav-user-menu"
                   toggleSideNav={() => setMenuExpanded(!menuExpanded)}
                   label={user && `${user.emailAddress}`}
                   icon={<UserIcon firstInitial={user ? user.firstName.charAt(0) : 'C'}
                                   lastInitial={user ? user.lastName.charAt(0) : "J"}/>}
                   expanded={menuExpanded}
                   onClick={() => setMenuExpanded(!menuExpanded)}>
        <LogoutLink label={"Log out"} onLogout={() => {
          logout()
          window.location.reload()
        }}/>
      </LinkGroup>
      : <LinkGroup className="vs-sidenav-user-menu"
                   toggleSideNav={() => setMenuExpanded(!menuExpanded)}
                   label={"Log in"}
                   icon={<UserIcon firstInitial={"C"} lastInitial={"J"}/>}
                   onClick={() => window.location.href = "/login"}>
      </LinkGroup>
  )
};
